import { FieldViewModel, IGenericAnalysisAlloc } from "../../../omnia"
import { ISoilService } from "../../../types"
import { IAnalysisLayerData } from "../map/analysis-layer"
import { GlobalAnalysisAlloc } from "./alloc-vm"
import { GlobalHealthySoilsAssessmentVM } from "./hsa-vm"

export class GlobalHealthySoilsAssessmentAlloc extends GlobalAnalysisAlloc {

    public field: FieldViewModel;

    static createFromAlloc(svc: ISoilService,
        analysis: GlobalHealthySoilsAssessmentVM,
        allocation: IGenericAnalysisAlloc) {

        var a = new GlobalHealthySoilsAssessmentAlloc()
        a.analysis = analysis
        a.allocation = allocation
        a.field = svc.findField(allocation.FieldId)

        return a;
    }

    static createAlloc(analysis: GlobalHealthySoilsAssessmentVM, data: IAnalysisLayerData): GlobalHealthySoilsAssessmentAlloc {
        var a = new GlobalHealthySoilsAssessmentAlloc();
        a.analysis = analysis;
        a.field = data.field;
        a.layerData = data;
        a.shown = true;

        var allocation = analysis.analysis.Allocations.filter(l => l.FieldId === data.field.fieldId);
        if (allocation.length) {
            a.allocation = allocation[0];
        }

        return a;
    }

    getDescription(): string {
        return this.field.description;
    }

    getId(): any {
        return this.field.fieldId;
    }

}
